<app-filter-header title="Filtrar Observaciones PDA" i18n-title (apply)="this.apply()" (reset)="this.reset()" (dismiss)="this.dismiss()"></app-filter-header>
<div class="modal-body">
  <div class="row col">
    <app-form-text-edit id="observacions-pda-filter-codi" class="col-sm-3" i18n-label label="Codi" [(value)]="this.filter.codi" number></app-form-text-edit>
    <app-filter-text-edit id="observacions-pda-filter-descripcio" class="col-sm-6" i18n-label label="Descripció" [(value)]="this.filter.descripcio" contains></app-filter-text-edit>
    <app-form-combo-edit  class="col-3" label="Tipo" i18n-label [items]="tipusDenuncia" textField="value" valueField="key" [(value)]="this.filter.tipus"></app-form-combo-edit>
  </div>
</div>
